const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverDeviceWelcomeRequestRecord extends AbstractCloverRequestRecord {
    constructor() {
        // @link https://docs.clover.com/reference/show_welcome
        const url = '/connect/v1/device/welcome';
        super(
            'POST',
            url
        );
    }
}

module.exports = CloverDeviceWelcomeRequestRecord;
